import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const News = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddNews = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditNews = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewNews = () => {
  return (
    
      <Detail />
    
  );
};
